// extracted by mini-css-extract-plugin
export default {"contents":"oJ-z","sectionHeading":"pJ-z"};